import calcFunctions from './calc';
import drawFunctions from './draw';
import data from './data';

/*******************************************/
export function restart(delay = true) {
  // console.log('[RESTART]');

  data.state = 'new';
  this.setPlayClickDisable(true);

  // const start = () => {
  //   data.playState = 'start';
  //   this.setPlayClickDisable(false);
  //   this.onPlayClick();
  // };

  if (!delay) {
    delay = 0;
  } else {
    delay = data.examples.reduce((max, el) => {
      if (el.interval > max) return el.interval;
      return max;
    }, 0);
  }
  setTimeout(init.bind(this), delay);
}

function init() {
  // console.log('[PROCESS]');
  const exampleIdx = this.getState().exampleIdx;
  // if (data.lastExampleIdx !== exampleIdx) {
  data.lastExampleIdx = exampleIdx;
  // init drawing for current example
  calcFunctions.initRec();
  const calcInit = data.examples[exampleIdx].calcInit;
  calcFunctions[calcInit](this.getState().coe);
  // }

  
  const svgContent = drawFunctions.drawInit();
  this.updateSvgContent(svgContent);
  
  data.state = 'pause';
  this.changePlayState('pause');
  this.setPlayClickDisable(false);
  // drawGraphics.bind(this)();
}

/*******************************************/
// play clicked
export function play() {
  this.setState(state => ({
    playState: state.playState === 'pause' ? 'play' : 'pause',
  }));
  data.state = 'in-play';
  drawGraphics.bind(this)();
}

// const advanceAuto = function () {
//   let exampleIdx = this.getState().exampleIdx;
//   if (data.autoPlay) {
//     exampleIdx++;
//     exampleIdx = exampleIdx >= data.examples.length - 1 ? 0 : exampleIdx;
//     this.setState({
//       exampleIdx: exampleIdx,
//     });
//     setTimeout(restart.bind(this), 0);
//   }
// };

const drawGraphics = function () {
  // console.log('[DRAW-GRAPHICS]');
  let svgContent = [];
  const interval = data.examples[this.getState().exampleIdx].interval;
  let idx = 0;
  // interval - time between each tick
  const intervalId = setInterval(drawTick.bind(this), interval);

  function drawTick() {
    // console.log('[DRAW-TICKS]');
    if (data.state === 'new') {
      clearInterval(intervalId);
      this.changePlayState('pause');
      data.state = 'start';
    } else if (this.getState().playState === 'play') {
      svgContent = drawFunctions.drawAll(idx);

      this.updateSvgContent(svgContent);

      idx++;
      if (idx >= data.colSize) {
        idx = 0;
        clearInterval(intervalId);
        data.state = 'start';
        this.changePlayState('pause');

        // advanceAuto.bind(this)();
      }
    }
  }
};
